import { AutoComplete, Input } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import "./MunicipalitySearch.css";
import { surveyService } from '../../services';
import { GlobalContext } from '../../contexts/GlobalContext';
import { authenticationService } from "../../services";

const MunicipalitySearchAnalytics = ({onSelect, loading, ...props}) => {
    const [municipalities, setMunicipalities] = useState([])
    const [options, setOptions] = useState([])
    const [searchTerm, setSearchTerm] = useState(null)
    const {selectedMunicipality, setSelectedMunicipality} = useContext(GlobalContext)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await surveyService.getRouterJLSWithStatus()
                const initialData = response?.map(d => (
                    {label: `${d.name} ${parseInt(d.status) && ' (Podržali projekt)' || ''}`, value: d.name, id: Number(d.id), status: parseInt(d.status)}  
                    ))
                setMunicipalities(initialData)
                setOptions(municipalities)
                if(authenticationService.currentUserValue?.jls_id) {
                    const userJls = authenticationService.currentUserValue?.jls_id+21
                    const jls = municipalities.find(m => m.id == userJls)
                    setSelectedMunicipality(jls)
                }
            }
            catch(error) {


            }
        }
        fetchData()
    }, [])

    const handleSearch = (searchText) => {
        !searchText ? setOptions(municipalities) :
        setOptions(municipalities.filter(m => m.value.toUpperCase().includes(searchText?.toUpperCase())))

        setSearchTerm(searchTerm)
    }

    const handleFocus = (searchText) => {
        !searchTerm ? setOptions(municipalities) :
        setOptions(municipalities.filter(m => m.value.toUpperCase().includes(searchTerm?.toUpperCase())))
    }

    const handleSelect = (val, option) => {
        const ciklopark_current_user = JSON.parse(localStorage.getItem("ciklopark_current_user"));
        if(!option.status&&ciklopark_current_user?.type!=1) {
            alert("Pregled projektnih rezultata po jedinicama lokalne samouprave omogućen je isključivo za one JLS-ove koji su podržali projekt!")
        }
        else {
            setSelectedMunicipality(option)
            onSelect && onSelect(option)
        }
        
    }

    const handleClear = () => {
        setSelectedMunicipality(null)
        onSelect && onSelect(null)
    }

    useEffect(() => {
       
        if(authenticationService.currentUserValue?.jls_id) {
            const userJls = authenticationService.currentUserValue?.jls_id+21
            const jls = municipalities.find(m => m.id == userJls)
            if(jls) {
                setSelectedMunicipality(jls)
                onSelect && onSelect(jls)
            }
        }
    }, [authenticationService.currentUserValue])

    return (<div className='municipality-search' {...props}>
        <AutoComplete
            allowClear
            backfill
            popup_class_name="municipality-search__dropdown"
            options={options}
            onSearch={handleSearch}
            onFocus={handleFocus}
            onSelect={handleSelect}
            onClear={handleClear}
            disabled={loading}
            defaultValue={selectedMunicipality}
            //options={options.map(o => ({label: renderTitle(o.label), options: o.choices?.map(c => renderItem(c))}))}
        >
            <Input size="large" placeholder={loading && "Učitavanje jedinica lokalne samouprave..." || "Pretraga po jedinici lokalne samouprave:"} />
        </AutoComplete>
        </div>
    )
}

export default MunicipalitySearchAnalytics;